$(document).ready(function () {
  var myproduct = $(".custom_our_products .multicolumn-list__item").attr(
    "attr"
  );
  $(".custom-featured-product[attr='" + myproduct + "']").addClass("active");
  $(
    ".custom_our_products .multicolumn-list__item[attr='" + myproduct + "']"
  ).addClass("active");
});
$(".custom_our_products .multicolumn-list__item").click(function () {
  var myproduct = $(this).attr("attr");
  $(".custom-featured-product").removeClass("active");
  $(".custom-featured-product[attr='" + myproduct + "']").addClass("active");

  $(".custom_our_products .multicolumn-list__item").removeClass("active");
  $(
    ".custom_our_products .multicolumn-list__item[attr='" + myproduct + "']"
  ).addClass("active");
});

function initSlider() {
  if (typeof $.fn.slick === 'undefined') {
    setTimeout(initSlider, 100);
    //console.log('initSlider 24 ... slick undefined');
    return;
  }
  console.log('initSlider 27 ... slick ready');
  var slidesToShow = 3;

  if ($(window).width() < 600) {
    slidesToShow = 1;
  } else if ($(window).width() < 989) {
    slidesToShow = 2;
  }

  $(".whole_slide").slick({
    infinite: true,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    prevArrow:
      '<button type="button" class="slick-prev pull-left"><svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54"><g><g opacity=".7"><path fill="#fff" d="M0 27C0 12.088 12.088 0 27 0s27 12.088 27 27-12.088 27-27 27S0 41.912 0 27z"/></g><g><g><path fill="none" stroke="#141313" stroke-linecap="round" stroke-miterlimit="20" stroke-width="2" d="M19.5 25.5l14 10"/></g><g><path fill="none" stroke="#141313" stroke-linecap="round" stroke-miterlimit="20" stroke-width="2" d="M19.5 25.5l14-10"/></g></g></g></svg></button>',
    nextArrow:
      '<button type="button" class="slick-next pull-right"><svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54"><g><g opacity=".7"><path fill="#fff" d="M0 27C0 12.088 12.088 0 27 0s27 12.088 27 27-12.088 27-27 27S0 41.912 0 27z"/></g><g><g><path fill="none" stroke="#141313" stroke-linecap="round" stroke-miterlimit="20" stroke-width="2" d="M34.5 25.5l-14 10"/></g><g><path fill="none" stroke="#141313" stroke-linecap="round" stroke-miterlimit="20" stroke-width="2" d="M34.5 25.5l-14-10"/></g></g></g></svg></button>',
  });
}
$(document).ready(function () {
  initSlider();
});
  $(window).on("resize", function () {
    if (typeof $.fn.slick !== 'undefined') {
      $(".whole_slide").slick("unslick");
      initSlider();
    }
  });




$(".faq-drawer__title").click(function () {
  $(".faq-drawer__trigger:checked").not($(this).prev()).prop("checked", false);
});

$(document).ready(function () {
  $(".button").wrap('<div class="magnetic">');
  $(".button:not(.product-form__submit)").wrapInner(
    "<div class='btntext'></div>"
  );

  $(".button:not(.product-form__submit)").mouseleave(function () {
    var $this = $(this);
    $this.addClass("mousl");
    setTimeout(function () {
      $this.removeClass("mousl");
    }, 150);
  });

  $(".button.product-form__submit").wrapInner("<div class='btntext'></div>");

  $(".button.product-form__submit").mouseleave(function () {
    var $this = $(this);
    $this.addClass("mousl");
    setTimeout(function () {
      $this.removeClass("mousl");
    }, 150);
  });

  var magnets = document.querySelectorAll(".magnetic1");
  var strength = 50;

  magnets.forEach((magnet) => {
    magnet.addEventListener("mousemove", moveMagnet);
    magnet.addEventListener("mouseout", function (event) {
      TweenMax.to(event.currentTarget, 1, { x: 0, y: 0, ease: Power4.easeOut });
    });
  });

  function moveMagnet(event) {
    var magnetButton = event.currentTarget;
    var bounding = magnetButton.getBoundingClientRect();

    //console.log(magnetButton, bounding)

    TweenMax.to(magnetButton, 1, {
      x:
        ((event.clientX - bounding.left) / magnetButton.offsetWidth - 0.5) *
        strength,
      y:
        ((event.clientY - bounding.top) / magnetButton.offsetHeight - 0.5) *
        strength,
      ease: Power4.easeOut,
    });

    //magnetButton.style.transform = 'translate(' + (((( event.clientX - bounding.left)/(magnetButton.offsetWidth))) - 0.5) * strength + 'px,'+ (((( event.clientY - bounding.top)/(magnetButton.offsetHeight))) - 0.5) * strength + 'px)';
  }
});

$(document).ready(function () {
  $(".product-tabs-section .content .list label span").wrapInner(
    "<div class='btntext'></div>"
  );

  $(".product-tabs-section .content .list label span").mouseleave(function () {
    var $this = $(this);
    $this.addClass("mousl");
    setTimeout(function () {
      $this.removeClass("mousl");
    }, 150);
  });

  var fixedDiv = $(".product__background");
  var bg = $(".goOnZoom");
  var bgcolor = $(".goOnZoom img");
  var scrollThreshold = 300;
  var dataColor = $(".goOnZoom img").attr('data-color');
  setTimeout(function () {
    scrollThreshold = $(".product__media-wrapper").innerHeight() - 500;
    console.log(scrollThreshold);
  }, 600);

  $(window).scroll(function () {
    if ($(window).scrollTop() >= scrollThreshold) {
      // Calculate the opacity based on the scroll position
      var opacity = 1 - ($(window).scrollTop() - scrollThreshold) / 600; // Adjust the divisor for sensitivity
      // Ensure opacity is between 0 and 1
      opacity = Math.min(1, Math.max(0, opacity));
      // Set the opacity of the fixed div
      fixedDiv.css("opacity", opacity);
      bg.css("background-size", 0);
      bgcolor.css("background-color", 'transparent');
    } else {
      bgcolor.css("background-color", dataColor);
       bg.css("background-size", 'auto');
      fixedDiv.css("opacity", 1);
    }
  });
});

$(document).on("click", ".product__accordion.accordion details", function () {
  $(".product__accordion.accordion details").removeAttr("open");

  $(this).attr("open");
});

// $("nav.header__inline-menu detailsw.mega-menu").hover(function(){
//     $(this).find(".mega-menu__content").slideDown("slow").animate({easing: 'easeOutBounce'});
//   $(this).find(".mega-menu__content").css("display","flex");
// });

// $("nav.header__inline-menu detailsw.mega-menu").click(function(){
//     $(".mega-menu__content").slideUp("slow");
// });
// $("#MainContent").hover(function(){
//     $(".mega-menu__content").slideUp("slow");
// });

// Mobile Menu

$(document).ready(function () {
  $("#mmTrigger1").click(function () {
    $(".mob-tab-btn").removeClass("active");
    $(this).addClass("active");
    $("nav.menu-drawer__navigation").hide("slow");
    $("nav.menu-drawer__navigation.mobile_menu_1").show("slow");
  });
  $("#mmTrigger2").click(function () {
    $(".mob-tab-btn").removeClass("active");
    $(this).addClass("active");
    $("nav.menu-drawer__navigation").hide("slow");
    $("nav.menu-drawer__navigation.mobile_menu_2").show("slow");
  });
});

/**** zoom functionality ***/
if ($(window).width() > 1024) {
  function initZoom() {
    if (typeof $.fn.slick === 'undefined') {
      setTimeout(initZoom, 100);
      //console.log('initZoom 24 ... slick undefined');
      return;
    }
    console.log('initSlider 27 ... slick ready');
    setTimeout(function () {
      $(".goOnZoom").mouseout(function () {
        if ($(".goOnZoom").hasClass("active")) {
          $(".goOnZoom").removeClass("active");
          $(".main-images").slick.refresh();
          $(".thumnail-images").slick.refresh();
        }
      });
      $(".zoom_btn").click(function () {
        $(".goOnZoom").addClass("active");
  
        //var imgsrc = $(this).find('img').attr('src');
        //$(this).css('background-image', 'url(' + imgsrc + ')');
      });
    }, 500);
  }
  initZoom();
}

function zoom(e) {
  var zoomer = e.currentTarget;
  e.offsetX ? (offsetX = e.offsetX) : (offsetX = e.touches[0].pageX);
  e.offsetY ? (offsetY = e.offsetY) : (offsetX = e.touches[0].pageX);
  x = (offsetX / zoomer.offsetWidth) * 100;
  y = (offsetY / zoomer.offsetHeight) * 100;
  zoomer.style.backgroundPosition = x + "% " + y + "%";
}
/**** zoom functionality end ***/

$(".zoom_btn_mob").click(function () {
  $('.main-images').addClass("active");
   $(".main-images.active").append('<button class="modal__close"><svg class="icon-close" role="img" aria-label="Close Icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M17.4139 4.00015L3.99966 17.4144L2.58545 16.0002L15.9997 2.58594L17.4139 4.00015Z" fill="black"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M3.99966 2.58594L17.4139 16.0002L15.9997 17.4144L2.58545 4.00015L3.99966 2.58594Z" fill="black"></path></svg></button>');
    $(".slick-arrow, .slick-dots").hide();

  
  //   $(".main-images").slick('refresh');
  // $(".slick-arrow, .slick-dots").hide();
    // setTimeout(function () {
        
    //     $(".main-images.active").append('<button class="modal__close"><svg class="icon-close" role="img" aria-label="Close Icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M17.4139 4.00015L3.99966 17.4144L2.58545 16.0002L15.9997 2.58594L17.4139 4.00015Z" fill="black"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M3.99966 2.58594L17.4139 16.0002L15.9997 17.4144L2.58545 4.00015L3.99966 2.58594Z" fill="black"></path></svg></button>');
    //     if ($(".main-images .cstm_btn_slider").length) {
    //       $(".main-images").append('<div class="cstm_btn_slider"></div>');
    //         $(".main-images").find(".slick-prev").appendTo(".cstm_btn_slider");
    //         $(".main-images").find(".slick-dots").appendTo(".cstm_btn_slider");
    //         $(".main-images").find(".slick-next").appendTo(".cstm_btn_slider");
    //         $(".slick-arrow, .slick-dots").show();
            
    //     } else {
           
    //     }
       
    // }, 1000);
});



$(document).on('click','.modal__close',function(){
    $(this).closest('.main-images').removeClass("active");
    $(this).hide();
  // $(".cstm_btn_slider").empty();
  $(".main-images")[0].slick('refresh');
   $(".main-images .slick-arrow, .main-images .slick-dots").hide();
});


$('.tabs-stage >div').hide();
$('.tabs-stage >div:first').show();
$('.tabs-nav li:first').addClass('tab-active');

$('.tabs-nav a').on('click', function(event){
  event.preventDefault();
  $('.tabs-nav li').removeClass('tab-active');
  $(this).parent().addClass('tab-active');
  $('.tabs-stage >div').hide();
  $($(this).attr('href')).show();
});

$(".accordion-item:first-child").closest(".accordion-contant").slideToggle();
 $(".accordion-item:first-child").toggleClass("active");    
            $(".accordion-titel").click(function(){
            $(this).parent(".accordion-item").find(".accordion-contant").slideToggle();
            $(this).parent(".accordion-item").prevAll(".accordion-item").find(".accordion-contant").slideUp();
            $(this).parent(".accordion-item").nextAll(".accordion-item").find(".accordion-contant").slideUp();

             $(this).parent(".accordion-item").toggleClass("active");    
             $(this).parent(".accordion-item").prevAll(".accordion-item").removeClass("active");
             $(this).parent(".accordion-item").nextAll(".accordion-item").removeClass("active");
            });



$(document).ready(function () {
  function initSlider_cstm_unlock_section() {
    if (typeof $.fn.slick === 'undefined') {
      setTimeout(initSlider_cstm_unlock_section, 100);
      //console.log('initSlider_cstm_unlock_section ... slick undefined');
      return;
    }
    console.log('initSlider_cstm_unlock_section ... 284');
    var slidesToShow = 3;

    if ($(window).width() < 600) {
      slidesToShow = 1;
    } else if ($(window).width() < 989) {
      slidesToShow = 2;
    }else if ($(window).width() < 1195) {
      slidesToShow = 3;
    }
    if ($(window).width() < 1195) {
      $(".cstm_unlock_section .multicolumn-list").slick({
        infinite: true,
        slidesToShow: slidesToShow,
        slidesToScroll: 1,
        dots: true,
        prevArrow:
          '<button type="button" class="slick-prev pull-left"><svg width="25" height="20" viewBox="0 0 25 20" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="Group"><path id="Vector" d="M10.2655 19L11.197 17.9462L3.00335 10.7032L24.5 10.7032L24.5 9.29675L3.00335 9.29675L11.197 2.05379L10.2655 0.999998L0.495749 9.63614L0.495749 10.3639L10.2655 19Z" fill="#1C1B1F" stroke="#1C1B1F"/></g></svg></button>',
        nextArrow:
          '<button type="button" class="slick-next pull-right"><svg width="25" height="20" viewBox="0 0 25 20" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="Group"><path id="Vector" d="M14.7345 1L13.803 2.0538L21.9967 9.29675L0.5 9.29675L0.5 10.7033L21.9967 10.7033L13.803 17.9462L14.7345 19L24.5043 10.3639V9.63614L14.7345 1Z" fill="#1C1B1F" stroke="#1C1B1F"/></g></svg></button>',
      });
    }
  }

  initSlider_cstm_unlock_section();

  // $(window).on("resize", function () {
  //   $(".current-favs .custom-inner, .cstm_unlock_section .multicolumn-list").slick("unslick");
  //   initSlider_cstm_unlock_section();
  // });
});


function initializeSlickSlider() {
  if (!window.jQuery || typeof window.jQuery.fn.slick === 'undefined') {
    setTimeout(initializeSlickSlider, 100);
    //console.log('initializeSlickSlider ... slick undefined');
    return;
  }
  console.log('initializeSlickSlider ... slick ready');
  $('.current-favs .custom-inner').not('.slick-initialized').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
     prevArrow:
            '<button type="button" class="slick-prev pull-left"><svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="Dropdown btn"><circle id="Ellipse 26" cx="23" cy="23" r="21.8" fill="white" stroke="#1C1B1F" stroke-width="1.6"></circle><g id="Group"><g id="Group_2"><path id="Vector" d="M31.75 25.7517L30.7255 24.846L23.6837 32.8121L23.6837 11.9125L22.3163 11.9125L22.3163 32.8121L15.2745 24.846L14.25 25.7517L22.6462 35.25L23.3538 35.25L31.75 25.7517Z" fill="#1C1B1F" stroke="#1C1B1F"></path></g></g></g></svg></button>',
          nextArrow:
            '<button type="button" class="slick-next pull-right"><svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="Dropdown btn"><circle id="Ellipse 26" cx="23" cy="23" r="21.8" fill="white" stroke="#1C1B1F" stroke-width="1.6"></circle><g id="Group"><g id="Group_2"><path id="Vector" d="M31.75 25.7517L30.7255 24.846L23.6837 32.8121L23.6837 11.9125L22.3163 11.9125L22.3163 32.8121L15.2745 24.846L14.25 25.7517L22.6462 35.25L23.3538 35.25L31.75 25.7517Z" fill="#1C1B1F" stroke="#1C1B1F"></path></g></g></g></svg></button>',
    responsive: [
      {
        breakpoint: 1195,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,       
          dots: true
        }
      },
      {
        breakpoint: 989,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }  
    ]
  });
}
initializeSlickSlider();

$(document).ready(function() {
    var min_height = $('.custom-inner .item.slick-current .item_content h2.font_30').height();   
    var min_height2 = $('.custom-inner .item.slick-current .item_content h4.lexend-deca').height(); 
    if (min_height) {       
        $('.item_content h2.font_30').css('min-height', min_height + 'px');
    } else {
        console.log('Element not found or height is 0.');
    }
   $('.item_content h4.lexend-deca').css('min-height', min_height2 + 'px');
});
// function instaFeed() {

//    var slidesToShow = 4;

//     if ($(window).width() < 600) {
//       slidesToShow = 1;
//     } else if ($(window).width() < 989) {
//       slidesToShow = 2;
//     }
  
//   $("#insta-feed").slick({
//     infinite: true,
//     centerMode: true,
//     slidesToShow: slidesToShow,
//     slidesToScroll: 1,
//     prevArrow:
//         '<button type="button" class="button slick-prev pull-left"><svg width="25" height="20" viewBox="0 0 25 20" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="Group"><path id="Vector" d="M10.2655 19L11.197 17.9462L3.00335 10.7032L24.5 10.7032L24.5 9.29675L3.00335 9.29675L11.197 2.05379L10.2655 0.999998L0.495749 9.63614L0.495749 10.3639L10.2655 19Z" fill="#1C1B1F" stroke="#1C1B1F"/></g></svg></button>',
//     nextArrow:
//         '<button type="button" class="button slick-next pull-right"><svg width="25" height="20" viewBox="0 0 25 20" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="Group"><path id="Vector" d="M14.7345 1L13.803 2.0538L21.9967 9.29675L0.5 9.29675L0.5 10.7033L21.9967 10.7033L13.803 17.9462L14.7345 19L24.5043 10.3639V9.63614L14.7345 1Z" fill="#1C1B1F" stroke="#1C1B1F"/></g></svg></button>',
//   });
// }

// $(document).ready(function () {
//   setTimeout(function() {
//     instaFeed();
//   }, 2000);
// });

// $(window).on("resize", function () {
//   $("#insta-feed").slick("unslick");
//   instaFeed();
// });

$(document).ready(function() {
    function wrapFooterMenu() {
        if ($(window).width() < 990) {
            if (!$('.footer-block--menu').parent().hasClass('footer_menu_wrap')) {
                $('.footer-block--menu').wrapAll('<div class="footer_menu_wrap" />');
            }
        } else {
            if ($('.footer-block--menu').parent().hasClass('footer_menu_wrap')) {
                $('.footer-block--menu').unwrap();
            }
        }
    }
    wrapFooterMenu();
    $(window).resize(function() {
        wrapFooterMenu();
    });
});


